import styled from "styled-components";

export const Avatar = styled.img`
  max-width: 180px;
  max-height: 180px;
  border-radius: 50%;
`;
